import { connect } from 'react-redux';
import BaseForm from '../BaseForm/BaseForm';
import { addUser, showError, clearErrors } from '../../redux/actions/users';

class UserCreateForm extends BaseForm {
  constructor(props) {
    super(props, {
      onSubmit: addUser,
      name: 'User',
      action: 'Add',
      type: 'create',
      isTypeForm: false,
    });
  }

  /**
   * Handle form validation
   */
  handleValidate(data) {
    if (this.props.model.didInvalidate) {
      this.props.dispatch(clearErrors());
    }
    if (!BaseForm.validator.isEmail(data.email)) {
      this.props.dispatch(showError('Invalid email address'));
      return false;
    }
    return data;
  }

  /**
   * Handle form reset
   */
  handleReset(dispatch, actions) {
    dispatch(actions.change('create.email', ''));
  }
}

const mapStateToProps = ({ users }) => ({
  model: users,
  fields: BaseForm.fields.users.create,
  values: {},
});

export default connect(mapStateToProps)(UserCreateForm);
